/*eslint-disable no-undef */
import { useState, useEffect } from 'react';
import BlobPanel from './Blob';
import EmployerPanel from './Employer';
import BlobViewListItem from './Blob/BlobViewListItem';
import EmployerViewListItem from './Employer/EmployerViewListItem';
import ShowMoreLess from '../../common/ListWithShowMoreLess';
import { Accordion } from 'react-bootstrap';

const BlobFilterPanel = ({
  onSelectedBlobCount,
  handleValChange,
  createUserFormData,
  isContinueClicked,
  nextStep,
  showEmployerOnly,
  onSelectedEmployerCount,
  selectedBlobData,
  selectedEmployerData,
  selectedLocationData,
  editAffiliatedRecords,
}) => {
  useEffect(() => {
    console.log('bbb rendered');
  }, []);
  const [selectedBlob, setSelectedBlob] = useState(
    selectedBlobData && selectedBlobData.length > 0
      ? selectedBlobData
      : createUserFormData.BLOBDetails.blobSelected,
  );
  const [blobAllData, setBlobAllData] = useState(
    createUserFormData.BLOBDetails.allBLOBData,
  );

  const [selectedEmployer, setSelectedEmployer] = useState(
    selectedEmployerData
      ? selectedEmployerData
      : createUserFormData.BLOBDetails.selectedEmployers,
  );
  const [employerAllData, setEmployerAllData] = useState(
    createUserFormData.BLOBDetails.allEmployersData || {},
  );

  const [selectedLocation, setSelectedLocation] = useState(
    selectedLocationData
      ? selectedLocationData
      : createUserFormData.BLOBDetails.selectedLocations,
  );
  const [locationAllData, setLocationAllData] = useState(
    createUserFormData.BLOBDetails.allLocationsData || {},
  );
  const [showMoreBlobs, setShowMoreBlobs] = useState(false);
  const [showMoreEmployers, setShowMoreEmployers] = useState(false);
  const [showMoreLocations, setShowMoreLocations] = useState(false);

  const [idx, setIdx] = useState([]);
  const [deleteBlobId, setDeleteBlobId] = useState('');

  const onSelectedBlobHandler = (selectedBlobLists) => {
    setSelectedBlob(selectedBlobLists);
  };

  const onSelectedEmployerHandler = (selectedEmpLists, blobId) => {
    if (blobId) {
      if (selectedEmpLists.length > 0) {
        const createEmpObj = {
          [selectedEmpLists[0].BlkOfBusOid]: selectedEmpLists,
        };
        let tempObj = { ...selectedEmployer };
        tempObj = Object.assign(tempObj, createEmpObj);
        setSelectedEmployer(tempObj);
      } else {
        if (Object.prototype.hasOwnProperty.call(selectedEmployer, blobId)) {
          const tempObj = { ...selectedEmployer };
          delete tempObj[blobId];
          setSelectedEmployer(tempObj);
        }
      }
    } else {
      setSelectedEmployer([...selectedEmpLists]);
    }
  };

  const onSelectedLocationHandler = (
    selectedlocationList,
    blkOfBusOid,
    clientOid,
  ) => {
    if (selectedlocationList.length > 0) {
      const createLocObj = {
        [selectedlocationList[0].ClientOid]: selectedlocationList,
      };
      const tempObj = Object.assign(selectedLocation, createLocObj);
      setSelectedLocation({ ...tempObj });
    } else {
      const tempObj = { ...selectedLocation };
      delete tempObj[clientOid];
      setSelectedLocation(tempObj);
    }
  };

  const onTrashButtonClickHandler = (e, deleteBlobId, deleteOid) => {
    setDeleteBlobId(deleteBlobId);
    e.stopPropagation();
    if (Object.prototype.hasOwnProperty.call(selectedEmployer, deleteOid)) {
      const tempObj = { ...selectedEmployer };
      delete tempObj[deleteOid];
      setSelectedEmployer(tempObj);
    }
    if (
      employerAllData &&
      Object.prototype.hasOwnProperty.call(employerAllData, deleteOid)
    ) {
      const tempObj = { ...employerAllData };
      delete tempObj[deleteOid];
      setEmployerAllData(tempObj);
    }

    if (selectedLocation) {
      const tempObj = { ...selectedLocation };
      Object.values([selectedLocation][0]).map((item) =>
        item.map((el) => {
          if (el.BlkOfBusOid === deleteOid) {
            delete tempObj[el.ClientOid];
          }
          return;
        }),
      );
      setSelectedLocation(tempObj);
    }

    if (locationAllData) {
      const tempObj = { ...locationAllData };
      Object.values([locationAllData][0]).map((item) =>
        item.map((el) => {
          if (el.BlkOfBusOid === deleteOid) {
            delete tempObj[el.ClientOid];
          }
          return;
        }),
      );
      setLocationAllData(tempObj);
    }
  };

  const unselectMultipleBlobs = (e, unselectedBlobs) => {
    unselectedBlobs &&
      unselectedBlobs.length > 0 &&
      unselectedBlobs.forEach((b) => {
        e.stopPropagation();
        if ((selectedEmployer, Object.prototype.hasOwnProperty.call(b.oid))) {
          const blobIdsArr = [];
          blobIdsArr.push(b.oid);
          blobIdsArr.forEach((e) => {
            delete selectedEmployer[e];
          });
          setSelectedEmployer(selectedEmployer);
        }

        if (
          employerAllData &&
          Object.prototype.hasOwnProperty.call(employerAllData, b.oid)
        ) {
          const blobIdsArr = [];
          blobIdsArr.push(b.oid);
          blobIdsArr.forEach((e) => {
            delete employerAllData[e];
          });
          setEmployerAllData(employerAllData);
        }

        if (selectedLocation) {
          Object.values([selectedLocation][0]).map((item) =>
            item.map((el) => {
              const empIdsArr = [];
              empIdsArr.push(el.ClientOid);
              empIdsArr.forEach((e) => {
                if (el.BlkOfBusOid === b.oid) {
                  delete selectedLocation[e];
                }
              });
              return;
            }),
          );
          setSelectedLocation(selectedLocation);
        }

        if (locationAllData) {
          Object.values([locationAllData][0]).map((item) =>
            item.map((el) => {
              const empIdsArr = [];
              empIdsArr.push(el.ClientOid);
              empIdsArr.forEach((e) => {
                delete locationAllData[e];
              });
              return;
            }),
          );
          setLocationAllData(locationAllData);
        }
      });
  };

  const onEmpTrashButtonClickHandler = (
    e,
    blobOid,
    clientOid,
    deleteEmployer,
  ) => {
    e.stopPropagation();
    if (!showEmployerOnly) {
      if (Object.prototype.hasOwnProperty.call(selectedEmployer, blobOid)) {
        let tempObj = { ...selectedEmployer };
        const filteredObj = [selectedEmployer]
          .map((item) => item[blobOid] || null)
          .filter((e1) => e1 !== null)
          .map((ele) =>
            ele
              .map((client) => client)
              .filter((del) => del.oid !== deleteEmployer.oid),
          );
        const finalObj = { [blobOid]: filteredObj[0] };
        tempObj = Object.assign(tempObj, finalObj);
        setSelectedEmployer(tempObj);
      }
      if (Object.prototype.hasOwnProperty.call(employerAllData, blobOid)) {
        const tempObj = employerAllData[blobOid]
          .map((ele) => ele)
          .map((empData) =>
            empData.oid === deleteEmployer.oid
              ? { ...empData, isChecked: false }
              : empData,
          );
        const finalObj = Object.assign(employerAllData, { [blobOid]: tempObj });
        setEmployerAllData(finalObj);
      }
    }
    if (showEmployerOnly) {
      if (selectedEmployer?.length > 0) {
        const filteredEmps = [...selectedEmployer].filter(
          (del) => del.oid !== deleteEmployer.oid,
        );
        setSelectedEmployer(filteredEmps);
      }
      if (employerAllData?.length > 0) {
        const tempEmps = [...employerAllData].map((empData) =>
          empData.oid === deleteEmployer.oid
            ? { ...empData, isChecked: false }
            : empData,
        );
        setEmployerAllData(tempEmps);
      }
    }

    if (
      selectedLocation &&
      Object.prototype.hasOwnProperty.call(selectedLocation, clientOid)
    ) {
      const tempObj = { ...selectedLocation };
      delete tempObj[clientOid];
      setSelectedLocation(tempObj);
    }

    if (
      locationAllData &&
      Object.prototype.hasOwnProperty.call(locationAllData, clientOid)
    ) {
      const tempObj = { ...locationAllData };
      delete tempObj[clientOid];
      setLocationAllData(tempObj);
    }
  };

  const onLocationTrashButtonClickHandler = (
    e,
    blobOid,
    clientOid,
    deleteLocation,
  ) => {
    e.stopPropagation();
    if (Object.prototype.hasOwnProperty.call(selectedLocation, clientOid)) {
      let tempObj = { ...selectedLocation };
      const filteredObj = [selectedLocation]
        .map((item) => item[clientOid] || null)
        .filter((e1) => e1 !== null)
        .map((ele) => ele.map((lcn) => lcn))
        .filter((el) => el !== null)
        .map((ele) =>
          ele.map((lcn) => lcn).filter((del) => del.oid !== deleteLocation.oid),
        );
      const finalObj = { [clientOid]: filteredObj[0] };
      tempObj = Object.assign(tempObj, finalObj);
      setSelectedLocation(tempObj);
    }

    if (Object.prototype.hasOwnProperty.call(locationAllData, clientOid)) {
      const tempObj = locationAllData[clientOid]
        .map((ele) => ele)
        .map((locData) =>
          locData.oid === deleteLocation.oid
            ? { ...locData, isChecked: false }
            : locData,
        );
      const finalObj = Object.assign(locationAllData, { [clientOid]: tempObj });
      setLocationAllData(finalObj);
    }
  };

  const selectedEmployerCount = (blobOid) => {
    if (
      selectedEmployer !== null &&
      Object.prototype.hasOwnProperty.call(selectedEmployer, blobOid)
    ) {
      const selectedEmpCount = [selectedEmployer]
        .map((item) => item[blobOid] || null)
        .filter((e1) => e1 !== null)[0].length;
      return selectedEmpCount > 0
        ? `${selectedEmpCount} Employers`
        : 'All Employers';
    } else {
      return 'All Employers';
    }
  };

  const selectedLocationCount = (clientOid) => {
    if (Object.prototype.hasOwnProperty.call(selectedLocation, clientOid)) {
      const selectedLocCount = [selectedLocation]
        .map((item) => item[clientOid] || null)
        .filter((e1) => e1 !== null)
        .map((ele) => ele.map((lcn) => lcn))
        .filter((el) => el !== null)[0].length;
      return selectedLocCount > 0
        ? `${selectedLocCount} Locations`
        : 'All Locations';
    } else {
      return 'All Locations';
    }
  };

  useEffect(() => {
    console.log('Inside UseEffect: BLOBBBBBB');
    if (isContinueClicked) {
      console.log('Inside UseEffect: BLOBBBBBB   true');
      const tempObj = {
        blobSelected: selectedBlob,
        allBLOBData: blobAllData,
        selectedEmployers: selectedEmployer,
        allEmployersData: employerAllData,
        selectedLocations: selectedLocation,
        allLocationsData: locationAllData,
      };

      if (showEmployerOnly) {
        let blobs = [];
        let blobIds = [];
        if (selectedEmployer?.length > 0) {
          selectedEmployer.forEach((emp, index) => {
            if (!blobIds.includes(emp.BlkOfBusOid)) {
              blobIds = [...blobIds, emp.BlkOfBusOid];
              blobs = [...blobs, { oid: emp.BlkOfBusOid }];
            }
            if (index === selectedEmployer?.length - 1) {
              tempObj.blobSelected = blobs;
              console.log(
                'Inside UseEffect: BLOBBBBBB   true ::: tempObj :::::  ',
                tempObj,
              );
              const event = { target: { name: 'BLOBDetails', value: tempObj } };
              handleValChange(event);
              nextStep();
            }
          });
        } else {
          nextStep();
        }
      } else {
        console.log(
          'Inside UseEffect: BLOBBBBBB   true ::: tempObj :::::  ',
          tempObj,
        );
        const event = { target: { name: 'BLOBDetails', value: tempObj } };
        handleValChange(event);
        nextStep();
      }
    }
  }, [isContinueClicked]);

  useEffect(() => {
    onSelectedBlobCount(selectedBlob?.length);
  }, [selectedBlob]);

  useEffect(() => {
    if (typeof onSelectedEmployerCount === 'function')
      onSelectedEmployerCount(selectedEmployer?.length);
  }, [selectedEmployer]);

  useEffect(() => {
    if (selectedBlobData && selectedBlobData.length > 0) {
      setSelectedBlob(selectedBlobData);
    }
  }, [selectedBlobData]);

  useEffect(() => {
    if (selectedEmployerData) {
      setSelectedEmployer(selectedEmployerData);
    }
  }, [selectedEmployerData]);

  useEffect(() => {
    if (selectedLocationData) {
      setSelectedLocation(selectedLocationData);
    }
  }, [selectedLocationData]);

  const onUnSelectedEmpHandler = (unSelectedEmp) => {
    console.log('onUnSelectedEmpHandler unSelectedEmp', unSelectedEmp);
    console.log('selectedLocation ABC', selectedLocation);
    unSelectedEmp &&
      unSelectedEmp.length > 0 &&
      unSelectedEmp.forEach((e) => {
        if (
          selectedLocation &&
          Object.prototype.hasOwnProperty.call(selectedLocation, e.oid)
        ) {
          const empIdsArr = [];
          empIdsArr.push(e.oid);
          empIdsArr.forEach((e) => {
            delete selectedLocation[e];
          });
          setSelectedLocation(selectedLocation);
        }

        if (
          locationAllData &&
          Object.prototype.hasOwnProperty.call(locationAllData, e.oid)
        ) {
          const empIdsArr = [];
          empIdsArr.push(e.oid);
          empIdsArr.forEach((e) => {
            delete locationAllData[e];
          });
          setLocationAllData(locationAllData);
        }
      });
  };

  const renderAccordion = () => {
    const RenderBlobItem = ({ data, index }) => {
      const blob = data; //selectedEmployerCount( blob?.oid )
      return (
        <BlobViewListItem
          blob={blob}
          onClick={() => {
            if (idx.includes(index)) {
              setIdx(idx.filter((i) => i !== index));
            } else {
              setIdx([...idx, index]);
            }
          }}
          accordionArrowClass={!idx.includes(index) ? 'down-arrow' : ''}
          allowEmployerSelection
          allowLocationSelection
          showBlobDelete
          showEmployerDelete
          showLocationDelete
          employerProps={{
            employerCount: selectedEmployerCount(blob?.oid),
            selectedEmployer:
              selectedEmployer != null && selectedEmployer !== []
                ? selectedEmployer[blob?.oid]
                : [],
            onSelectedEmployerHandler: onSelectedEmployerHandler,
            employerAllData: employerAllData,
            setEmployerAllData: setEmployerAllData,
            onEmpTrashButtonClickHandler: onEmpTrashButtonClickHandler,
          }}
          onDeleteClick={(e) =>
            onTrashButtonClickHandler(e, blob?.BlkOfBusId, blob?.oid)
          }
          locationProps={{
            onSelectedLocationHandler: onSelectedLocationHandler,
            locationAllData: locationAllData,
            setLocationAllData: setLocationAllData,
            selectedLocation: selectedLocation,
            selectedLocationCount: selectedLocationCount,
            onLocationTrashButtonClickHandler:
              onLocationTrashButtonClickHandler,
          }}
          showMoreLocations={showMoreLocations}
          setShowMoreLocations={setShowMoreLocations}
          showMoreEmployers={showMoreEmployers}
          setShowMoreEmployers={setShowMoreEmployers}
          selectedEmployerData={selectedEmployerData}
          selectedLocationData={selectedLocationData}
          onUnSelectedEmpHandler={onUnSelectedEmpHandler}
          editAffiliatedRecords={editAffiliatedRecords}
        />
      );
    };
    return selectedBlob?.length > 0 ? (
      <Accordion>
        <ShowMoreLess
          data={selectedBlob}
          RenderItemComponent={RenderBlobItem}
          showMoreLabel="Block of Business(es)"
          keyProperty={'BlkOfBusId'}
          showMore={showMoreBlobs}
          setShowMore={setShowMoreBlobs}
        />
      </Accordion>
    ) : null;
  };

  const renderAccordionWithoutBlobs = () => {
    console.log('*******************************************', [
      selectedEmployer,
    ]);
    const RenderEmployerListItem = ({ data, index: idx }) => {
      const client = data;
      return (
        <EmployerViewListItem
          client={client}
          locationProps={{
            onSelectedLocationHandler: onSelectedLocationHandler,
            locationAllData: locationAllData,
            setLocationAllData: setLocationAllData,
            selectedLocation: selectedLocation[client.oid] || [],
            selectedLocationCount: selectedLocationCount,
            onLocationTrashButtonClickHandler:
              onLocationTrashButtonClickHandler,
            locationCount: selectedLocationCount(client.oid),
          }}
          allowLocationSelection
          showDelete
          showLocationDelete
          onDeleteClick={(e) =>
            onEmpTrashButtonClickHandler(e, null, client.oid, client)
          }
          showMoreLocations={showMoreLocations}
          setShowMoreLocations={setShowMoreLocations}
          selectedEmployerData={selectedEmployerData}
          selectedLocationData={selectedLocationData}
          editAffiliatedRecords={editAffiliatedRecords}
        />
      );
    };
    return (
      <div>
        {selectedEmployer?.length > 0 ? (
          <ShowMoreLess
            RenderItemComponent={RenderEmployerListItem}
            showMoreLabel="Employers"
            data={selectedEmployer}
            showMore={showMoreEmployers}
            setShowMore={setShowMoreEmployers}
          />
        ) : null}
      </div>
    );
  };

  useEffect(() => {
    const tempObj = {
      blobSelected: selectedBlob,
      allBLOBData: blobAllData,
      selectedEmployers: selectedEmployer,
      allEmployersData: employerAllData,
      selectedLocations: selectedLocation,
      allLocationsData: locationAllData,
    };
    const event = { target: { name: 'BLOBDetails', value: tempObj } };
    handleValChange(event);
  }, [selectedBlob, selectedEmployer, selectedLocation]);

  return (
    <>
      {!showEmployerOnly && (
        <BlobPanel
          deleteBlobId={deleteBlobId}
          onSelectedBlobHandler={onSelectedBlobHandler}
          blobAllData={blobAllData}
          setBlobAllData={setBlobAllData}
          selectedBlobData={selectedBlobData}
          unselectMultipleBlobs={unselectMultipleBlobs}
          editAffiliatedRecords={editAffiliatedRecords}
        />
      )}

      {showEmployerOnly && (
        <EmployerPanel
          showEmployerOnly
          onSelectedEmpHandler={onSelectedEmployerHandler}
          employerAllData={employerAllData}
          setEmployerAllData={setEmployerAllData}
          selectedEmployerData={selectedEmployer}
          onUnSelectedEmpHandler={onUnSelectedEmpHandler}
          //selectedLocation={selectedLocation}
          //setSelectedLocation={setSelectedLocation}
          editAffiliatedRecords={editAffiliatedRecords}
        />
      )}

      <div className="mt-2">
        {showEmployerOnly ? renderAccordionWithoutBlobs() : renderAccordion()}
      </div>
    </>
  );
};

export default BlobFilterPanel;
